import React from 'react';
import { Users, BarChart3, CreditCard, Cpu, ShieldCheck, Building2, Anchor } from 'lucide-react';
import { cn } from '@/lib/utils';

export type AdminTab = 'users' | 'stats' | 'subscriptions' | 'tokens' | 'security' | 'pros' | 'ports';

interface AdminSidebarProps {
  activeTab: AdminTab;
  onTabChange: (tab: AdminTab) => void;
}

const menuItems = [
  { id: 'users' as const, label: 'Gestion des utilisateurs', icon: Users },
  { id: 'subscriptions' as const, label: 'Gestion des abonnements', icon: CreditCard },
  { id: 'ports' as const, label: 'Gestion des ports', icon: Anchor },
  { id: 'pros' as const, label: 'Professionnels des ports', icon: Building2 },
  { id: 'stats' as const, label: 'Statistiques', icon: BarChart3 },
  { id: 'tokens' as const, label: 'Consommation IA', icon: Cpu },
  { id: 'security' as const, label: 'Sécurité & Chiffrement', icon: ShieldCheck },
];

export const AdminSidebar = ({ activeTab, onTabChange }: AdminSidebarProps) => {
  return (
    <aside className="w-64 min-h-[calc(100vh-4rem)] border-r bg-card">
      <nav className="p-4 space-y-2">
        {menuItems.map((item) => (
          <button
            key={item.id}
            onClick={() => onTabChange(item.id)}
            className={cn(
              "w-full flex items-center gap-3 px-4 py-3 rounded-lg text-left transition-colors",
              activeTab === item.id
                ? "bg-nautic text-white"
                : "hover:bg-muted text-foreground"
            )}
          >
            <item.icon className="h-5 w-5" />
            <span className="font-medium">{item.label}</span>
          </button>
        ))}
      </nav>
    </aside>
  );
};
